// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".cf0b9e00125c51d9953362a8ad74f19b2892823c.chunk.js";
};